var _defs, _path, _path2, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.616,
    height: 21.499,
    viewBox: "0 0 36.616 21.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.258,5.8a8.674,8.674,0,0,1,6.413,2.379A8.763,8.763,0,0,1,63.05,14.64a13.3,13.3,0,0,1-1.478,6.384,11.821,11.821,0,0,1-4.182,4.566,11.083,11.083,0,0,1-6.132,1.7,9.191,9.191,0,0,1-4.61-1.123,7.8,7.8,0,0,1-3.074-3.118,9.576,9.576,0,0,1-1.094-4.684,12.679,12.679,0,0,1,.916-4.876,12.945,12.945,0,0,1,2.512-4.019,11.511,11.511,0,0,1,3.768-2.689A10.95,10.95,0,0,1,54.258,5.8Zm-.665,4.285a5.083,5.083,0,0,0-2.955,1.02,7.892,7.892,0,0,0-3.325,6.531,6.428,6.428,0,0,0,1.093,3.812A3.872,3.872,0,0,0,51.776,23a5.32,5.32,0,0,0,2.955-.975,7.388,7.388,0,0,0,2.453-2.63,8.2,8.2,0,0,0,.931-3.99,6.073,6.073,0,0,0-1.093-3.827,3.99,3.99,0,0,0-3.428-1.492Z",
    transform: "translate(-42.478 -5.793)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.142,5.8a8.674,8.674,0,0,1,6.413,2.379,8.763,8.763,0,0,1,2.379,6.458,13.3,13.3,0,0,1-1.478,6.384,11.821,11.821,0,0,1-4.182,4.566,11.083,11.083,0,0,1-6.132,1.7,9.191,9.191,0,0,1-4.61-1.123,7.8,7.8,0,0,1-3.177-3.118,9.575,9.575,0,0,1-1.093-4.684,12.678,12.678,0,0,1,.916-4.876,12.945,12.945,0,0,1,2.556-4.019,11.512,11.512,0,0,1,3.827-2.689A10.95,10.95,0,0,1,65.142,5.8Zm-.635,4.285a5.083,5.083,0,0,0-2.955,1.02,7.892,7.892,0,0,0-3.325,6.531,6.428,6.428,0,0,0,1.094,3.812A3.872,3.872,0,0,0,62.689,23a5.32,5.32,0,0,0,2.955-.975,7.388,7.388,0,0,0,2.423-2.63A8.2,8.2,0,0,0,69,15.408,6.073,6.073,0,0,0,67.9,11.581,3.99,3.99,0,0,0,64.506,10.089Z",
    transform: "translate(-37.329 -5.793)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(10.834 3.513)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(27.37 3.513)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.a8c8137b2b55dd16e4bc1672297b4bec.svg";
export { ForwardRef as ReactComponent };